<template>
  <div class="problem-tab tab">
    <div class="tab-title" v-text="$t('app.modals.help.problem.title')" />
    <div class="choice-container">
      <div v-for="choice in state.problems" :key="choice.id" class="choice" @click="emits('next', choice)">
        <div class="round-icon">
          <i class="bi" :class="choice.icon" />
        </div>
        <div class="choice-name" v-text="choice.name" />
        <p v-text="choice.description" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive } from "vue";

const emits = defineEmits(["next"]);

const { t } = useI18n();

const state = reactive({
  problems: [
    {
      id: "1",
      icon: "bi-clock-history",
      name: t("app.modals.help.problem.pb1.title"),
      description: t("app.modals.help.problem.pb1.text"),
    },
    {
      id: "2",
      icon: "bi-person-slash",
      name: t("app.modals.help.problem.pb2.title"),
      description: t("app.modals.help.problem.pb2.text"),
    },
  ],
});
</script>
